import type { Finding } from '../finding'
import type { GpsFixReading } from '../gpsFix'

export interface GpsStreamTrust {
  positionsUsable: boolean
  timeTrusted: boolean
  speedTrusted: boolean
}

export const UNCHECKED_TRUST: Readonly<GpsStreamTrust> = Object.freeze({
  positionsUsable: true,
  timeTrusted: true,
  speedTrusted: true,
})

export interface GpsStreamVerdict {
  trust: GpsStreamTrust
  finding: Finding | null
}

export interface GpsStreamCheck {
  id: string
  run(fixes: readonly GpsFixReading[], trust: GpsStreamTrust): GpsStreamVerdict
}
